import API from '@/api'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    data: [],
    crop: null,
    fieldInfo: null,
    loaded: false,
    is_opened: false,
    defaultDate: null,
    colordata: null,
    nitrogenAmount: 0,
    hectares: {
      used: 0,
      max: 0,
      available: 0,
      is_available: false,
    },
    loading: false,
    // images: [],
    images: [

    ],
    selectedSatellite: 'sentinel-s2-l1c',
    selectedModel: 'ndvi',
    satellites: [
      'sentinel-s2-l1c',
      'landsat-pds',
      'sentinel-s2-l2a'
    ],
    models: ['ndvi', 'msavi2', 'rgb'],
    imageURL: null,
    dates: [],
    selectedDate: null,
    nitrogenMeta: null,
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    selectField(state, data) {
      state.fieldInfo = data;
    },
    open(state) {
      state.is_opened = true;
    },
    close(state) {
      state.is_opened = false;
    },
    setImageURL(state, data) {
      state.imageURL = data;
    },
    setSatellite(state, data) {
      state.selectedSatellite = state.satellites[data];
    },
    setModel(state, data) {
      state.selectedModel = state.models[data];
    },
    setDates(state, data) {
      state.dates = data;
    },
    saveDate(state, data) {
      state.selectedDate = data;
    },
    saveCrop(state, data) {
      state.crop = data;
    },
    toggleLoading(state, data) {
      state.loading = data;
    },
    saveImages(state, data) {
      state.images = data;
    },
    setDefaultDate(state, data) {
      state.defaultDate = data;
    },
    saveColorData(state, data) {
      state.colordata = data;
    },
    saveNitrogenMeta(state, data) {
      state.nitrogenMeta = data;
    },
    saveNitrogenAmount(state, data) {
      state.nitrogenAmount = data;
    }

  },
  actions: {

    selectField({rootGetters, state, commit}, id) {
      let data = rootGetters['farms/fields'].find(x => x.id == id);
      if(!data) {
        commit('selectField', null);
        return false;
      } else {
        commit('selectField', data);
      }
    },
    open({commit}) {
      commit('open');
    },
    close({commit}) {
      commit('close');
    },
    selectModel({state, commit}, id) {
      commit('setModel', id);
    },
    selectSatellite({state, commit}, id) {
      commit('setSatellite', id);
    },
    setDates({state, commit}) {
      // commit('setDates', null)
      // commit('setDefaultDate', null);
      if(state.images && state.images.length) {
        let urls = state.images;
        let dates = [];
        let regex = /([0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]))/g;
        urls.forEach((el, i) => {


          let date = {
            id: i,
            label: moment(el.match(regex)[0]).format("Do MMM YYYY"),
            value: el.match(regex)[0],
          }
          if(el.includes('vultusOne')) {

          } else {
            dates.push(date);
          }


        })
        commit('setDefaultDate', dates[0]);
        commit('setDates', dates)
      }

    },
    selectDate({state, commit}, data) {
      commit('saveDate', data);
    },
    selectImage({state, getters, commit}) {
      if(state.selectedSatellite && state.selectedModel && state.selectedDate) {
        let img = state.images.find(x => x.includes(state.selectedDate))
        if(!img) {
          img = null;
          console.log('No image found!');
          return false;
        }
        console.log('Image was found: ', img);
        commit('setImageURL', img);
      }
    },
    setCrop({commit}, data) {
      commit('saveCrop', data);
    },
    saveImages({commit, dispatch}, data) {
      commit('saveImages', data);
      dispatch('setDates');
    }


  },
  getters: {

    data(state) {
      return state.data;
    },
    fieldInfo(state) {
      return state.fieldInfo;
    },
    is_opened(state) {
      return state.is_opened;
    },
    images(state) {
      return state.images;
    },
    image(state) {
      return state.imageURL;
    },
    satellite(state) {
      return state.selectedSatellite;
    },
    model(state) {
      return state.selectedModel;
    },
    dates(state) {
      return state.dates;
    },
    date(state) {
      return state.selectedDate;
    },
    crop(state) {
      return state.crop;
    },
    loading(state) {
      return state.loading;
    },
    defaultDate(state) {
      return state.defaultDate;
    },
    colordata(state) {
      if(state.colordata) {
        return state.colordata.find( x => x.includes(state.selectedDate) );
      } else {
        return null;
      }

    },
    nitrogenMeta(state) {
      return state.nitrogenMeta;
    },
    nitrogenAmount(state) {
      return state.nitrogenAmount;
    }


  }
}
